






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/components/UI/Modal.vue';
import { CartItem } from '@/store/models';
import ui from '@/store/modules/ui';
import currency from '@/filters/currency';

@Component({
    components: {
        Modal,
    },
})
export default class OmnibusPrice extends Vue {
    @Prop() public item!: CartItem;

    get regularPrice() {
        return this.item.extension_attributes.extoriginal_price;
    }

    get finalPrice() {
        return this.item.extension_attributes.extcustom_price || this.item.extension_attributes.extfinal_price;
    }

    get omnibusPrice() {
        return this.item.extension_attributes.extomnibus_price;
    }

    get omnibusPriceFormatted() {
        return currency(this.omnibusPrice);
    }

    get showOmnibusPrice() {
        return this.omnibusPrice && this.omnibusPrice < this.regularPrice;
    }

    public openModal(item: CartItem) {
        ui.openModal(`omnibus-modal${item.item_id}`);
    }

    public closeModal(item: CartItem) {
        ui.closeModal(`omnibus-modal${item.item_id}`);
    }

    public getDiscountPercentage(regularPrice: number, finalPrice: number) {
        return `${Math.round(((regularPrice - finalPrice) / regularPrice) * 100)}%`;
    }
}
